import Vue from 'vue';
import Vuelidation from 'vuelidation';

Vue.use(Vuelidation);

export default {
	name: 'vuelidation'
};